import PropTypes from 'prop-types'

import { iconUnlock } from 'resources/images'

import { CircleIconContainer, Image, Progress, ProgressContainer } from './styles'

const UNLOCK_ICON_HEIGHT = 14
const UNLOCK_ICON_WIDTH = UNLOCK_ICON_HEIGHT * 0.809 // Aspect ratio 17/21

const ProgressBar = ({ color, height, progress, shouldDisplayIcon = false }) => {
  let width
  if (progress <= 0) {
    width = '0%'
  } else if (progress > 100) {
    width = '100%'
  } else {
    width = `${progress}%`
  }

  return (
    <>
      <ProgressContainer>
        <Progress color={color} height={height} width={width} />
      </ProgressContainer>
      {shouldDisplayIcon && (
        <CircleIconContainer>
          <Image
            src={iconUnlock}
            style={{
              height: UNLOCK_ICON_HEIGHT,
              width: UNLOCK_ICON_WIDTH,
            }}
          />
        </CircleIconContainer>
      )}
    </>
  )
}

ProgressBar.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
  shouldDisplayIcon: PropTypes.bool,
}

export default ProgressBar
